import { useCallback, useState } from 'react';

/**
 * « Bientôt dans votre régie » : l'utilisateur peut replier la section. Une
 * préférence locale, par compte et par navigateur, comme la langue et le design
 * (`languageStorage.ts`, `appearance/designStore.ts`) : rien n'est écrit côté
 * serveur. Stockage refusé ou plein : le choix reste actif pour la page courante.
 */
export function bientotStorageKey(compteId: string): string {
  return `artosera-bientot-masque:${encodeURIComponent(compteId)}`;
}

const volatile = new Map<string, boolean>();

export function readBientotMasque(compteId: string | null): boolean {
  if (!compteId || typeof window === 'undefined') return false;
  const cle = bientotStorageKey(compteId);
  const enMemoire = volatile.get(cle);
  if (enMemoire !== undefined) return enMemoire;
  try {
    return window.localStorage.getItem(cle) === '1';
  } catch {
    return false;
  }
}

export function storeBientotMasque(compteId: string, masque: boolean): void {
  const cle = bientotStorageKey(compteId);
  try {
    if (masque) window.localStorage.setItem(cle, '1');
    else window.localStorage.removeItem(cle);
    volatile.delete(cle);
  } catch {
    volatile.set(cle, masque);
  }
}

/** La section est-elle repliée ? Lue une fois, puis tenue en état. */
export function useBientotMasque(compteId: string | null): [boolean, (masque: boolean) => void] {
  const [masque, setMasque] = useState(() => readBientotMasque(compteId));
  const changer = useCallback(
    (valeur: boolean): void => {
      setMasque(valeur);
      if (compteId) storeBientotMasque(compteId, valeur);
    },
    [compteId],
  );
  return [masque, changer];
}
